module.exports = __webpack_public_path__ + "assets/img/2fdcbf07c8e8fba9dfe50bfe01ef46d9.svg";